/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { CopilotChatState, CopilotChatSlots } from './CopilotChat.types';

/**
 * Render the final JSX of CopilotChat
 */
export const renderCopilotChat_unstable = (state: CopilotChatState): JSXElement => {
  assertSlots<CopilotChatSlots>(state);

  // TODO Add additional slots in the appropriate place
  return <state.root />;
};
